import { Button, Header } from '@kanda-libs/ks-design-library';
import useHelpModal from 'components/HelpModal/useHelpModal';
import { URLS } from 'config';
import { useLeadsContext } from 'pages/Leads/context';
import { Link } from 'react-router-dom';

const LeadHeaderMobile: React.FunctionComponent = function () {
  const { archive } = useLeadsContext();
  const { showHelpModal } = useHelpModal();
  if (archive)
    return (
      <Header.Base
        hideNumber
        help={(e) => {
          if (e && typeof e.stopPropagation === 'function') {
            e.stopPropagation();
          }
          showHelpModal();
        }}
      >
        <Link to={URLS.leads}>
          <Button.Icon
            id="home-mobile-back"
            icon="chevron-left"
            className="-ml-4"
          />
        </Link>
      </Header.Base>
    );
  return (
    <Header.Main
      hideNumber
      help={(e) => {
        if (e && typeof e.stopPropagation === 'function') {
          e.stopPropagation();
        }
        showHelpModal();
      }}
      linkComponent={Link}
    />
  );
};

export default LeadHeaderMobile;
